export const getAvatarSrc = (avatar: string | undefined | null): string => {
    if (!avatar) {
        // ?v=2 cache-busts previously cached URLs (images were previosly served with a 1-year immutable cache)
        return "/avatars/male-avatar.svg?v=2";
    }
    return avatar;
};
